module.exports = __webpack_public_path__ + "img/farzana-christopher-17.b0682d92.jpg";